import { render, staticRenderFns } from "./AddEditOwnerModal.vue?vue&type=template&id=d57d4504"
import script from "./AddEditOwnerModal.vue?vue&type=script&lang=js"
export * from "./AddEditOwnerModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports